/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum EAuthError {
  AUTH_BAD_CREDENTIALS = 'AUTH_BAD_CREDENTIALS',
  AUTH_INVALID_REFRESH_TOKEN = 'AUTH_INVALID_REFRESH_TOKEN',
  AUTH_INVALID_ACCESS_TOKEN = 'AUTH_INVALID_ACCESS_TOKEN',
  AUTH_NO_ACCESS_RIGHTS = 'AUTH_NO_ACCESS_RIGHTS',
  AUTH_EMAIL_ALREADY_EXISTS = 'AUTH_EMAIL_ALREADY_EXISTS',
  AUTH_RECENT_PASSWORD_CANNOT_BE_REUSED = 'AUTH_RECENT_PASSWORD_CANNOT_BE_REUSED',
  AUTH_INCORRECT_CURRENT_PASSWORD = 'AUTH_INCORRECT_CURRENT_PASSWORD',
  AUTH_USER_SESSION_CANNOT_BE_DELETED = 'AUTH_USER_SESSION_CANNOT_BE_DELETED',
  AUTH_INCORRECT_CONFIRMATION_CODE = 'AUTH_INCORRECT_CONFIRMATION_CODE',
  AUTH_INCORRECT_ACTIVATION_CODE = 'AUTH_INCORRECT_ACTIVATION_CODE',
  AUTH_USER_SESSION_NOT_FOUND = 'AUTH_USER_SESSION_NOT_FOUND',
  AUTH_EMAIL_FAILED = 'AUTH_EMAIL_FAILED',
  AUTH_INVALID_XSRF_TOKEN = 'AUTH_INVALID_XSRF_TOKEN',
}

export enum EFileError {
  FILE_EXPORT_UNAVAILABLE = 'FILE_EXPORT_UNAVAILABLE',
  FILE_CONVERT_TO_FILE_UNAVAILABLE = 'FILE_CONVERT_TO_FILE_UNAVAILABLE',
  FILE_CANNOT_BE_DELETED = 'FILE_CANNOT_BE_DELETED',
  FILE_ID_NOT_FOUND = 'FILE_ID_NOT_FOUND',
}

export enum EInvitationError {
  INVITATION_CANCELED = 'INVITATION_CANCELED',
  INVITATION_REGISTERED_CANNOT_BE_CHANGED = 'INVITATION_REGISTERED_CANNOT_BE_CHANGED',
  INVITATION_INCORRECT_TOKEN = 'INVITATION_INCORRECT_TOKEN',
  INVITATION_NOT_FOUND = 'INVITATION_NOT_FOUND',
}

export enum EOAuth2Error {
  OAUTH2UNSUPPORTED = 'OAUTH2_UNSUPPORTED',
  OAUTH2INCORRECTPROVIDER = 'OAUTH2_INCORRECT_PROVIDER',
  OAUTH2EMAILNOTFOUND = 'OAUTH2_EMAIL_NOT_FOUND',
}

export enum EPaymentError {
  PAYMENT_ERROR = 'PAYMENT_ERROR',
}

export enum EPlanError {
  PLAN_END_OF_SUBSCRIPTION_DATE = 'PLAN_END_OF_SUBSCRIPTION_DATE',
  PLAN_EXPIRED = 'PLAN_EXPIRED',
  PLAN_ID_NOT_FOUND = 'PLAN_ID_NOT_FOUND',
  PLAN_IS_UNAVAILABLE = 'PLAN_IS_UNAVAILABLE',
  PLAN_LIMIT_ID_NOT_FOUND = 'PLAN_LIMIT_ID_NOT_FOUND',
}

export enum EPrice {
  PRICE_ID_NOT_FOUND = 'PRICE_ID_NOT_FOUND',
}

export enum EQrCodeError {
  QR_CODE_TYPE_NOT_AVAILABLE = 'QR_CODE_TYPE_NOT_AVAILABLE',
  QR_CODE_ALREADY_HAS_OWNER = 'QR_CODE_ALREADY_HAS_OWNER',
  QR_CODE_NOT_RELATED = 'QR_CODE_NOT_RELATED',
  QR_CODE_NOT_AVAILABLE = 'QR_CODE_NOT_AVAILABLE',
  QR_CODE_ID_NOT_FOUND = 'QR_CODE_ID_NOT_FOUND',
  QR_CODE_TEMPLATE_NOT_RELATED = 'QR_CODE_TEMPLATE_NOT_RELATED',
  QR_CODE_TEMPLATE_ID_NOT_FOUND = 'QR_CODE_TEMPLATE_ID_NOT_FOUND',
  QR_CODE_DESIGN_ID_NOT_FOUND = 'QR_CODE_DESIGN_ID_NOT_FOUND',
  QR_CODE_VCARD_ID_NOT_FOUND = 'QR_CODE_VCARD_ID_NOT_FOUND',
  QR_CODE_PDF_ID_NOT_FOUND = 'QR_CODE_PDF_ID_NOT_FOUND',
  QR_CODE_LOGO_ID_NOT_FOUND = 'QR_CODE_LOGO_ID_NOT_FOUND',
  QR_CODE_WEBSITE_ID_NOT_FOUND = 'QR_CODE_WEBSITE_ID_NOT_FOUND',
  QR_CODE_MULTILINK_ID_NOT_FOUND = 'QR_CODE_MULTILINK_ID_NOT_FOUND',
  QR_CODE_CANNOT_ASSIGN_TO_ANONYMOUS_USER = 'QR_CODE_CANNOT_ASSIGN_TO_ANONYMOUS_USER',
  QR_CODE_CANNOT_CONVERT_CSV = 'QR_CODE_CANNOT_CONVERT_CSV',
  QR_CODE_CANNOT_BE_CREATED = 'QR_CODE_CANNOT_BE_CREATED',
  QR_CODE_BULK_CREATION_CANNOT_BE_EMPTY = 'QR_CODE_BULK_CREATION_CANNOT_BE_EMPTY',
  QRCODEBULKCREATIONCANNOTBEMORETHEN199ITEMS = 'QR_CODE_BULK_CREATION_CANNOT_BE_MORE_THEN_199_ITEMS',
  QR_CODE_LIMIT_EXCEEDED = 'QR_CODE_LIMIT_EXCEEDED',
  USER_HAS_LIMITED_BULK_QR_CODE_GENERATION = 'USER_HAS_LIMITED_BULK_QR_CODE_GENERATION',
  QR_CODE_HAS_BEEN_DELETED = 'QR_CODE_HAS_BEEN_DELETED',
  QR_CODE_LIMIT = 'QR_CODE_LIMIT',
  QR_CODE_INVALID_GTIN = 'QR_CODE_INVALID_GTIN',
}

export enum ERestrictionError {
  MAX_LABELS_USED_RESTRICTION = 'MAX_LABELS_USED_RESTRICTION',
  MAX_QR_CODE_USED_RESTRICTION = 'MAX_QR_CODE_USED_RESTRICTION',
  MAX_SCAN_USED_RESTRICTION = 'MAX_SCAN_USED_RESTRICTION',
  PLAN_SUBSCRIPTION_RESTRICTION = 'PLAN_SUBSCRIPTION_RESTRICTION',
  PLAN_CREATION_QR_CODE_RESTRICTION = 'PLAN_CREATION_QR_CODE_RESTRICTION',
  PLAN_TEMPLATE_RESTRICTION = 'PLAN_TEMPLATE_RESTRICTION',
  PLAN_GPS_RESTRICTION = 'PLAN_GPS_RESTRICTION',
  PLAN_SCAN_RESTRICTION = 'PLAN_SCAN_RESTRICTION',
  MAX_BULK_QR_CODE_USED_RESTRICTION = 'MAX_BULK_QR_CODE_USED_RESTRICTION',
  PLAN_RESTRICTION = 'PLAN_RESTRICTION',
  PLAN_WHITE_LABEL_RESTRICTION = 'PLAN_WHITE_LABEL_RESTRICTION',
  PLAN_TEAMS_RESTRICTION = 'PLAN_TEAMS_RESTRICTION',
  PLAN_API_ACCESS_RESTRICTION = 'PLAN_API_ACCESS_RESTRICTION',
}

export enum ESubscriptionError {
  SUBSCRIPTION_ALREADY_CANCELED = 'SUBSCRIPTION_ALREADY_CANCELED',
  SUBSCRIPTION_CAN_NOT_RENEW = 'SUBSCRIPTION_CAN_NOT_RENEW',
  SUBSCRIPTION_DOES_NOT_EXISTED = 'SUBSCRIPTION_DOES_NOT_EXISTED',
  SUBSCRIPTION_NEED_TO_CANCEL_TO_CHANGE_CURRENCY = 'SUBSCRIPTION_NEED_TO_CANCEL_TO_CHANGE_CURRENCY',
  SUBSCRIPTION_CAN_NOT_DOWNGRADED = 'SUBSCRIPTION_CAN_NOT_DOWNGRADED',
  SUBSCRIPTION_STILL_ACTIVE = 'SUBSCRIPTION_STILL_ACTIVE',
  SUBSCRIPTION_HAS_NOT_ANY_SCHEDULED_UPDATE = 'SUBSCRIPTION_HAS_NOT_ANY_SCHEDULED_UPDATE',
  SUBSCRIPTION_CANNOT_UPGRADE_TRIALING = 'SUBSCRIPTION_CANNOT_UPGRADE_TRIALING',
  SUBSCRIPTION_ID_NOT_FOUND = 'SUBSCRIPTION_ID_NOT_FOUND',
  SUBSCRIPTION_INVALID_CUSTOMER_GENERATION = 'SUBSCRIPTION_INVALID_CUSTOMER_GENERATION',
  SUBSCRIPTION_NO_ACTIVE_TRIAL = 'SUBSCRIPTION_NO_ACTIVE_TRIAL',
  SUBSCRIPTION_TRIAL_EXTENSION_ALREADY_USED = 'SUBSCRIPTION_TRIAL_EXTENSION_ALREADY_USED',
}

export enum EUserError {
  USER_INCORRECT_CONFIRMATION_CODES = 'USER_INCORRECT_CONFIRMATION_CODES',
  USER_EMAIL_NOT_FOUND = 'USER_EMAIL_NOT_FOUND',
  USER_ID_NOT_FOUND = 'USER_ID_NOT_FOUND',
  USER_CANNOT_BE_ACTIVATED_OR_BANNED = 'USER_CANNOT_BE_ACTIVATED_OR_BANNED',
  USER_CANNOT_CHANGE_OF_EXPIRATION_DATE = 'USER_CANNOT_CHANGE_OF_EXPIRATION_DATE',
  USER_CANNOT_CHANGE_OF_EXPIRATION_DATE_BEFORE_NOW = 'USER_CANNOT_CHANGE_OF_EXPIRATION_DATE_BEFORE_NOW',
  USER_EMAIL_CONFIRMATION_BLOCKED = 'USER_EMAIL_CONFIRMATION_BLOCKED',
  USER_EMAIL_NOT_VERIFIED = 'USER_EMAIL_NOT_VERIFIED',
  USER_EMAIL_CONFIRMATION_EXPIRED = 'USER_EMAIL_CONFIRMATION_EXPIRED',
  USER_HAS_DISPUTED_PAYMENT = 'USER_HAS_DISPUTED_PAYMENT',
  USER_ALREADY_TAKEN_SUBDOMAIN = 'USER_ALREADY_TAKEN_SUBDOMAIN',
  USER_HAS_NOT_BUSINESS_PLAN = 'USER_HAS_NOT_BUSINESS_PLAN',
  USER_SETTING_NOT_FOUND = 'USER_SETTING_NOT_FOUND',
  USER_SUBDOMAIN_NOT_ENABLED = 'USER_SUBDOMAIN_NOT_ENABLED',
}

export interface Error {
  message: string;
  /** Base error code interface */
  errorCode: ErrorCode;
  args?: (object | null)[];
  template?: string | null;
  /** @format int32 */
  transactStep?: number | null;
  /** present on non-prod envs only */
  unsafeDetails?: string;
}

/** Base error code interface */
export type ErrorCode = BaseErrorCode &
  (
    | BaseErrorCodeTypeMapping<'EPlanError', any>
    | BaseErrorCodeTypeMapping<'EAuthError', any>
    | BaseErrorCodeTypeMapping<'ERestrictionError', any>
    | BaseErrorCodeTypeMapping<'EQrCodeError', any>
    | BaseErrorCodeTypeMapping<'EOAuth2Error', any>
    | BaseErrorCodeTypeMapping<'EFileError', any>
    | BaseErrorCodeTypeMapping<'EUserError', any>
    | BaseErrorCodeTypeMapping<'ESubscriptionError', any>
    | BaseErrorCodeTypeMapping<'EInvitationError', any>
    | BaseErrorCodeTypeMapping<'EPaymentError', any>
    | BaseErrorCodeTypeMapping<'EPriceError', any>
  );

export interface ErrorResponse {
  /** @format int64 */
  timestamp: number;
  /** @format int32 */
  status: number;
  errors: Error[];
}

export interface ErrorRestrictionResponse {
  /** @format int64 */
  timestamp: number;
  /** @format int32 */
  status: number;
  errors: Error[];
  errorCodes: ErrorCode[];
}

export interface EmailPreferenceInDto {
  token: string;
  qrNotification: boolean;
  trialLifecycle: boolean;
  tips: boolean;
}

export interface EmailPreferenceInfoOutDto {
  email: string;
  qrNotification: boolean;
  trialLifecycle: boolean;
  tips: boolean;
}

/** @default "EUR" */
export enum ECurrency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
}

/** @default "QUARTERLY" */
export enum EPlanCycle {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
}

export interface SubscriptionInDto {
  /**
   * @format uuid
   * @default "207fd6bd-fc50-404a-96c3-ed47ef3af591"
   */
  planId: string;
  /**
   * @format uuid
   * @default "aeb3d760-a642-497d-ae81-1d67296b1c0d"
   */
  priceId?: string;
  planCycle: EPlanCycle;
  currency: ECurrency;
  /** @default "https://osdb.io" */
  successRedirectURL: string;
  /** @default "https://osdb.io" */
  errorRedirectURL: string;
  /** @default false */
  allowPromotionCodes?: boolean;
}

export interface SubscriptionGatewayOutDto {
  url?: string | null;
  isScheduledDowngrade?: boolean | null;
  isScheduledDowngradeToFree?: boolean | null;
  scheduledId?: string | null;
}

export interface SubscriptionCancelFeedbackInDto {
  primaryReason?: string;
  featuresMissingOrImprove?: string;
  howToKeepYouAsCustomer?: string;
  commentsOrSuggestions?: string;
  cancelImmediately?: boolean;
}

export interface DesignInDto {
  template?: TemplateInDto;
  /** @format uuid */
  libraryId?: string;
  /**
   * @format int32
   * @example 0
   */
  logoSize?: number;
  frameType: EFrameType;
  frameText?: string;
  /**
   * @format int32
   * @example 0
   */
  frameTextSize?: number;
  /** @example "#000000" */
  frameTextColor: string;
  /** @example "#000000" */
  frameBackgroundColor: string;
  /** @example "#FFFFFF" */
  backgroundColor: string;
  patternType: EPatternType;
  cornerType: ECornerType;
  /** @example "#000000" */
  patternColor: string;
  /** @example "#000000" */
  cornerColor: string;
  reusable?: boolean;
}

/** @example "SQUARE" */
export enum ECornerType {
  SQUARE = 'SQUARE',
  ROUNDED = 'ROUNDED',
  FULL_CIRCLE = 'FULL_CIRCLE',
}

/** @example "NONE" */
export enum EFrameType {
  NONE = 'NONE',
  BORDER_LABEL_BOTTOM = 'BORDER_LABEL_BOTTOM',
  BORDER_LABEL_TOP = 'BORDER_LABEL_TOP',
  ARROW_LABEL_TOP = 'ARROW_LABEL_TOP',
  ARROW_LABEL_BOTTOM = 'ARROW_LABEL_BOTTOM',
  BORDER_SPACE_LABEL_BOTTOM = 'BORDER_SPACE_LABEL_BOTTOM',
  BORDER_SPACE_LABEL_TOP = 'BORDER_SPACE_LABEL_TOP',
  BORDER_INTERRUPTION = 'BORDER_INTERRUPTION',
  NO_BORDER = 'NO_BORDER',
  BORDER = 'BORDER',
}

/** @example "SQUARE" */
export enum EPatternType {
  SQUARE = 'SQUARE',
  CLASSY = 'CLASSY',
  CLASSY_ROUNDED = 'CLASSY_ROUNDED',
  DOTS = 'DOTS',
  EXTRA_ROUNDED = 'EXTRA_ROUNDED',
  ROUNDED = 'ROUNDED',
}

export interface TemplateInDto {
  /** @example "Title template" */
  title: string;
}

export interface DesignOutDto {
  /** @format uuid */
  id: string;
  createdBy?: UserBaseOutDto;
  template?: TemplateOutDto;
  library?: LibraryOutDto;
  isReusable: boolean;
  /** @format int32 */
  logoSize: number;
  frameType: EFrameType;
  frameText?: string | null;
  /** @format int32 */
  frameTextSize: number;
  frameTextColor: string;
  frameBackgroundColor: string;
  backgroundColor: string;
  patternType: EPatternType;
  cornerType: ECornerType;
  patternColor: string;
  cornerColor: string;
  /** @format date-time */
  createdDate: string;
  reusable?: boolean;
}

export enum ECustomerGen {
  GEN1 = 'GEN_1',
  GEN2 = 'GEN_2',
  GEN3 = 'GEN_3',
  GEN4 = 'GEN_4',
  GEN5 = 'GEN_5',
  GEN6 = 'GEN_6',
  GEN7 = 'GEN_7',
}

export enum ECustomerSegment {
  STUDENT = 'STUDENT',
  NON_PROFIT_OR_CHARITY = 'NON_PROFIT_OR_CHARITY',
  TEACHER = 'TEACHER',
  LARGE_COMPANY = 'LARGE_COMPANY',
  PERSONAL = 'PERSONAL',
  SMALL_BUSINESS = 'SMALL_BUSINESS',
}

export enum ELanguage {
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  DUTCH = 'DUTCH',
  SPANISH = 'SPANISH',
  ITALIAN = 'ITALIAN',
}

export enum ELibraryType {
  DESIGN_LOGO = 'DESIGN_LOGO',
  MULTILINK_LOGO = 'MULTILINK_LOGO',
  VCARD_LOGO = 'VCARD_LOGO',
  LINK_LOGO = 'LINK_LOGO',
  GS1LOGO = 'GS1_LOGO',
  WIFI_LOGO = 'WIFI_LOGO',
}

export enum ERole {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_CUSTOMER = 'ROLE_CUSTOMER',
}

export enum EUserStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  BANNED = 'BANNED',
  DELETED = 'DELETED',
}

export interface FileOutDto {
  /** @format uuid */
  id: string;
  fileName: string;
  /** @format date-time */
  createdDate: string;
}

export interface LibraryOutDto {
  /** @format uuid */
  id: string;
  file: FileOutDto;
  libraryType: ELibraryType;
  /** @format date-time */
  createdDate: string;
}

export interface TemplateOutDto {
  /** @format uuid */
  id: string;
  title: string;
  createdBy: UserBaseOutDto;
  /** @format date-time */
  createdDate: string;
}

export interface UserBaseOutDto {
  /** @format uuid */
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  language: ELanguage;
  currency: ECurrency;
  /** @format int64 */
  totalCodes?: number;
  /** @format int64 */
  totalScans?: number;
  /** @format int64 */
  monthlyScans?: number;
  shouldAskForGPSCoordinates?: boolean;
  accountNotification?: boolean;
  qrNotification?: boolean;
  marketingNotification?: boolean;
  phone?: string | null;
  address?: string | null;
  birthDate?: string | null;
  role: ERole;
  /** @format uuid */
  avatarId?: string | null;
  company?: string | null;
  status: EUserStatus;
  customerGen: ECustomerGen;
  customerSegment?: ECustomerSegment;
  /** @format date-time */
  upsellTopBannerHiddenDate?: string | null;
  subdomain?: string | null;
  isSubdomainEnabled: boolean;
  /** @format date-time */
  createdDate: string;
  isFirstScanSeen: boolean;
  isFirstQrCodeCreated: boolean;
}

export interface TemplateDeleteInDto {
  ids: string[];
}

export interface QrCodeMultiDeleteInDto {
  qrCodeIds: string[];
}

export interface QRCodeConnectInDto {
  generatedQRCodes?: string[];
}

export enum ECodeType {
  WEBSITE = 'WEBSITE',
  MULTILINK = 'MULTILINK',
  PDF = 'PDF',
  V_CARD = 'V_CARD',
  GS1 = 'GS1',
  WIFI = 'WIFI',
}

export enum ECreatedWithFlow {
  MANUAL = 'MANUAL',
  BULK = 'BULK',
}

export enum ELinkType {
  CUSTOM = 'CUSTOM',
  FACEBOOK = 'FACEBOOK',
  LINKEDIN = 'LINKEDIN',
  TIKTOK = 'TIKTOK',
  TELEGRAM = 'TELEGRAM',
  WHATSAPP = 'WHATSAPP',
  INSTAGRAM = 'INSTAGRAM',
  YOUTUBE = 'YOUTUBE',
  SKYPE = 'SKYPE',
  TWITTER = 'TWITTER',
}

export interface GS1LinkOutDto {
  /** @format uuid */
  id: string;
  library?: LibraryOutDto;
  title: string;
  url: string;
  linkType: ELinkType;
  /** @format date-time */
  createdDate: string;
}

export interface GS1OutDto {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdDate: string;
  library?: LibraryOutDto;
  gtin: string;
  title: string;
  description?: string;
  designBgColor: string;
  designTitleColor: string;
  designDescriptionColor: string;
  buttonBgColor: string;
  buttonTextColor: string;
  buttonHoverColor: string;
  buttonBorderColor: string;
  customLinks: GS1LinkOutDto[];
  socialLinks: GS1LinkOutDto[];
}

export interface LinkOutDto {
  /** @format uuid */
  id: string;
  library?: LibraryOutDto;
  title: string;
  url: string;
  linkType: ELinkType;
  /** @format date-time */
  createdDate: string;
}

export interface MultilinkOutDto {
  /** @format uuid */
  id: string;
  library?: LibraryOutDto;
  title: string;
  description?: string;
  designBgColor: string;
  designTitleColor: string;
  designDescriptionColor: string;
  buttonBgColor: string;
  buttonTextColor: string;
  buttonHoverColor: string;
  buttonBorderColor: string;
  customLinks: LinkOutDto[];
  socialLinks: LinkOutDto[];
  /** @format date-time */
  createdDate: string;
}

export interface PDFOutDto {
  /** @format uuid */
  id: string;
  file: FileOutDto;
  /** @format date-time */
  createdDate: string;
}

export interface PageResponseQRCodeOutDto {
  result: QRCodeOutDto[];
  /** @format int64 */
  total: number;
}

export interface QRCodeOutDto {
  id: string;
  name: string;
  design?: DesignOutDto;
  createdBy?: UserBaseOutDto;
  shouldAskForGPSCoordinates: boolean;
  codeType: ECodeType;
  /** @format int64 */
  amountOfScans?: number | null;
  /** @format int64 */
  monthlyScans?: number | null;
  publicLogoType?: string | null;
  /** @format date-time */
  expireDate?: string | null;
  /** @format date-time */
  createdDate: string;
  isOverScanLimit?: boolean | null;
  website?: WebsiteOutDto;
  pdf?: PDFOutDto;
  multilink?: MultilinkOutDto;
  vcard?: VCardOutDto;
  gs1?: GS1OutDto;
  wifi?: WiFiQRCodeOutDto;
  /** @format int64 */
  totalDownloads?: number | null;
  /** @format date-time */
  lastDownloadDate?: string | null;
  isCustomized?: boolean | null;
  hasOwnerDisputedPayment?: boolean | null;
  createdWithFlow: ECreatedWithFlow;
  subdomain?: string | null;
  isPasswordProtected?: boolean | null;
  password?: string | null;
  /** @format int32 */
  duplicateCount?: number | null;
}

export interface VCardLinkOutDto {
  /** @format uuid */
  id: string;
  linkType: ELinkType;
  url: string;
  /** @format date-time */
  createdDate: string;
}

export interface VCardOutDto {
  /** @format uuid */
  id: string;
  library?: LibraryOutDto;
  fullName: string;
  phoneNumber: string;
  alternativePhoneNumber?: string | null;
  email: string;
  website: string;
  companyName: string;
  jobPosition: string;
  street: string;
  postalCode: string;
  city: string;
  state: string;
  country: string;
  designPrimaryColor: string;
  designSecondaryColor: string;
  designNameColor: string;
  designTitleColor: string;
  designTextColor: string;
  designIconColor: string;
  designTextHoverColor: string;
  buttonText: string;
  /** @format int32 */
  buttonSize: number;
  buttonBgColor: string;
  buttonTextColor: string;
  buttonHoverColor: string;
  buttonBorderColor: string;
  links: VCardLinkOutDto[];
  /** @format date-time */
  createdDate: string;
}

export interface WebsiteOutDto {
  /** @format uuid */
  id: string;
  url: string;
  /** @format date-time */
  createdDate: string;
}

export interface WiFiQRCodeOutDto {
  /** @format uuid */
  id: string;
  library?: LibraryOutDto;
  title: string;
  description?: string;
  ssid: string;
  encryption: 'WPA' | 'WPA2' | 'WEP' | 'NONE';
  password?: string;
  hidden: boolean;
  /** @format date-time */
  createdDate: string;
}

export interface CustomerInDto {
  firstName?: string;
  lastName?: string;
  /** @example "12345678912" */
  phone?: string;
  /** @example "Kharkiv, Ukraine" */
  address?: string;
  /** @example "1991-10-17" */
  birthDate?: string;
  /** @format uuid */
  avatarId?: string;
  /** @example "OSDB" */
  company?: string;
  language?: ELanguage;
  currency?: ECurrency;
  customerSegment?: ECustomerSegment;
  shouldAskForGPSCoordinates?: boolean;
  isFirstScanSeen?: boolean;
  isFirstQrCodeCreated?: boolean;
  accountNotification?: boolean;
  qrNotification?: boolean;
  marketingNotification?: boolean;
  /** @format date-time */
  upsellTopBannerHiddenDate?: string;
  /** @format date-time */
  endOfSubscriptionDate?: string;
  isSubdomainEnabled?: boolean;
}

export enum EExperimentGroup {
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum EInvoiceStatus {
  PAID = 'PAID',
  FAILED = 'FAILED',
  OPEN = 'OPEN',
  DRAFT = 'DRAFT',
  VOID = 'VOID',
  UNCOLLECTIBLE = 'UNCOLLECTIBLE',
}

export enum EPlanStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
}

export enum EPlanType {
  FREE = 'FREE',
  TRIAL = 'TRIAL',
  BASIC = 'BASIC',
  STARTER = 'STARTER',
  PREMIUM = 'PREMIUM',
  PRO = 'PRO',
  BUSINESS = 'BUSINESS',
}

export enum EScanAnalyticUnit {
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export enum ESettingType {
  AUTH2FA = 'AUTH_2FA',
}

export enum ETeamMemberRole {
  NONE = 'NONE',
  OWNER = 'OWNER',
  MEMBER = 'MEMBER',
}

export enum EUsageWarning {
  USAGE80PERCENT = 'USAGE_80_PERCENT',
  USAGE100PERCENT = 'USAGE_100_PERCENT',
}

export interface PlanDetailsOutDto {
  planType: EPlanType;
  planStatus: EPlanStatus;
  /** @format date-time */
  endOfCurrentSubscription: string;
  /** @format date-time */
  endOfTrialCurrentSubscription?: string;
  hasDisputedPayment?: boolean | null;
  /** @format int32 */
  amountMaxQrCodes?: number | null;
  /** @format int32 */
  amountMaxScans?: number | null;
  hasTemplates: boolean;
  hasLabels: boolean;
  hasRealTimeDataDashboard: boolean;
  hasTrackScanTimeOfDay: boolean;
  hasTrackScanLocation: boolean;
  hasTrackScanDevice: boolean;
  hasTrackScanGPS: boolean;
  hasQrDesignCustomisations: boolean;
  hasBulkQrCodeGeneration: boolean;
  /** @format int32 */
  amountOfMaxBulkQrCode?: number | null;
  gdprCompliant: boolean;
  ccpaCompliant: boolean;
  knowledgeBase: boolean;
  emailSupport: boolean;
  dedicatedCustomerSuccessManager: boolean;
  hasFileExtensions: boolean;
  hasTeamAccess: boolean;
  fileExtensions: string[];
  hasWhiteLabel: boolean;
  hasApiKey: boolean;
  /** @format int32 */
  scanAnalyticsQuantity?: number | null;
  scanAnalyticsUnit?: EScanAnalyticUnit | null;
}

export interface PlanUserOutDto {
  /** @format uuid */
  id: string;
  name: string;
  price?: PriceOutDto;
  scheduledUpdate?: ScheduleUpdateOutDto;
  lastInvoiceId?: string | null;
  lastInvoiceStatus?: EInvoiceStatus;
  canceledReason?: string | null;
  isTrial?: boolean;
  /** @format date-time */
  createdDate: string;
}

export interface PriceOutDto {
  /** @format uuid */
  id?: string | null;
  /** @format double */
  price?: number | null;
  planCycle?: EPlanCycle;
  planCurrency: ECurrency;
  customerGen: ECustomerGen;
  /** @format date-time */
  createdDate?: string | null;
}

export interface ScheduleUpdateOutDto {
  planType: EPlanType;
  planCycle?: EPlanCycle;
  /** @format date-time */
  nextPeriodStart: string;
  scheduleSubscriptionId?: string;
}

export interface UserOutDto {
  /** @format uuid */
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  language: ELanguage;
  currency: ECurrency;
  /** @format int64 */
  totalCodes?: number;
  /** @format int64 */
  totalScans?: number;
  /** @format int64 */
  monthlyScans?: number;
  shouldAskForGPSCoordinates?: boolean;
  accountNotification?: boolean;
  qrNotification?: boolean;
  marketingNotification?: boolean;
  phone?: string | null;
  address?: string | null;
  birthDate?: string | null;
  role: ERole;
  /** @format uuid */
  avatarId?: string | null;
  company?: string | null;
  status: EUserStatus;
  /** @format date-time */
  createdDate: string;
  isFirstScanSeen: boolean;
  isFirstQrCodeCreated: boolean;
  /** @format date-time */
  providedReviewForTrialDate?: string | null;
  settings: UserSettingOutDto[];
  plan?: PlanUserOutDto;
  currentPlanDetails?: PlanDetailsOutDto;
  /** @format date-time */
  stripeSyncedDate?: string | null;
  /** @format uuid */
  currentSubscriptionId?: string | null;
  /** @format uuid */
  previousSubscriptionId?: string | null;
  customerId?: string | null;
  chargebeeId?: string | null;
  activeCampaignId?: string | null;
  /** @format date-time */
  lastActiveCampaignSyncedDate?: string | null;
  anyCodeDownloaded: boolean;
  anyCodeCustomized: boolean;
  hasVerifiedEmail?: boolean | null;
  isOldPlanUser: boolean;
  usageWarning?: EUsageWarning;
  /** @format date-time */
  newUsageResetDate?: string | null;
  customerGen: ECustomerGen;
  customerSegment?: ECustomerSegment;
  /** @format date-time */
  upsellTopBannerHiddenDate?: string | null;
  subdomain?: string | null;
  isSubdomainEnabled: boolean;
  /** @format uuid */
  teamId?: string | null;
  teamMemberRole: ETeamMemberRole;
  teamMemberRoles?: ETeamMemberRole[] | null;
  experimentGroup: EExperimentGroup;
}

export interface UserSettingOutDto {
  /** @format uuid */
  id: string;
  type: ESettingType;
  isEnabled: boolean;
}

export interface EmailPreferenceUpdateInDto {
  qrNotification: boolean;
  trialLifecycle: boolean;
  tips: boolean;
}

export interface AdminInDto {
  firstName: string;
  lastName: string;
  /** @example "12345678912" */
  phone?: string;
  /** @example "Kharkiv, Ukraine" */
  address?: string;
  /** @example "1991-10-17" */
  birthDate?: string;
  /** @format uuid */
  avatarId?: string;
  language?: ELanguage;
}

export interface AdminOutDto {
  /** @format uuid */
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  language: ELanguage;
  phone?: string;
  address?: string;
  birthDate?: string;
  role: ERole;
  /** @format uuid */
  avatarId?: string;
  status: EUserStatus;
  /** @format date-time */
  createdDate: string;
}

export interface CheckEmailConfirmationInDto {
  /** @example "okogutenko+client@osdb.io" */
  email: string;
  confirmationCode: string;
}

export interface CheckEmailConfirmationOutDto {
  hasVerifiedEmail: boolean;
  /** Only provided in non-production environments. Indicates if email sending was skipped for test emails */
  dev_PASSWORD_AFTER_SIGNUP?: string | null;
  /** @format int32 */
  countOfFailedConfirmationCode?: number | null;
  /** @format date-time */
  lastConfirmationEmailDate?: string | null;
  /** @format date-time */
  nextConfirmationEmailDate?: string | null;
}

export interface CheckEmailRegisteredInDto {
  /** @example "okogutenko+client@osdb.io" */
  email: string;
}

export interface CheckEmailRegisteredOutDto {
  isEmailRegistered: boolean;
}

export interface GeoDetailsInDto {
  /** @format double */
  lat: number;
  /** @format double */
  lng: number;
  /** @format double */
  accuracy?: number;
}

export interface ScanInDto {
  /** @format uuid */
  deviceId: string;
  gps?: GeoDetailsInDto;
  password?: string;
}

/**
 * Status of the scan request
 * @example "SUCCESS"
 */
export enum EScanResponseStatus {
  SUCCESS = 'SUCCESS',
  PASSWORD_REQUIRED = 'PASSWORD_REQUIRED',
  OWNER_HAS_DISPUTE = 'OWNER_HAS_DISPUTE',
  PASSWORD_INCORRECT = 'PASSWORD_INCORRECT',
}

export interface ScanResponseDto {
  /** Status of the scan request */
  status: EScanResponseStatus;
  /**
   * Indicates if password is required to view the QR code content
   * @example true
   */
  passwordRequired?: boolean;
  /**
   * Indicates if password provided was incorrect
   * @example false
   */
  passwordIncorrect?: boolean;
  qrCode?: QRCodeOutDto;
}

export interface GS1InDto {
  /** @format uuid */
  libraryId?: string;
  /** @pattern ^(\d{8}|\d{12}|\d{13}|\d{14})$ */
  gtin: string;
  title: string;
  description?: string;
  designBgColor: string;
  designTitleColor: string;
  designDescriptionColor: string;
  buttonBgColor: string;
  buttonTextColor: string;
  buttonHoverColor: string;
  buttonBorderColor: string;
  customLinks: GS1LinkInDto[];
  socialLinks: GS1LinkInDto[];
}

export interface GS1LinkInDto {
  /** @format uuid */
  libraryId?: string;
  title: string;
  url: string;
  linkType: ELinkType;
}

export interface LinkInDto {
  /** @format uuid */
  libraryId?: string;
  title: string;
  url: string;
  linkType: ELinkType;
}

export interface MultilinkInDto {
  /** @format uuid */
  libraryId?: string;
  title: string;
  description?: string;
  designBgColor: string;
  designTitleColor: string;
  designDescriptionColor: string;
  buttonBgColor: string;
  buttonTextColor: string;
  buttonHoverColor: string;
  buttonBorderColor: string;
  customLinks: LinkInDto[];
  socialLinks: LinkInDto[];
}

export interface PDFInDto {
  /** @format uuid */
  fileId: string;
}

export interface QRCodeInDto {
  /** @example "Name qr code" */
  name: string;
  design?: DesignInDto;
  /** @format uuid */
  templateId?: string;
  codeType: ECodeType;
  publicLogoType?: string;
  website?: WebsiteInDto;
  pdf?: PDFInDto;
  multilink?: MultilinkInDto;
  vcard?: VCardInDto;
  gs1?: GS1InDto;
  wifi?: WiFiQRCodeInDto;
  googleClickId?: string;
  microsoftClickId?: string;
  /** @example "mySecurePassword123" */
  password?: string;
}

export interface VCardInDto {
  /** @format uuid */
  libraryId?: string;
  fullName: string;
  phoneNumber: string;
  alternativePhoneNumber?: string;
  email?: string;
  website?: string;
  companyName?: string;
  jobPosition?: string;
  street?: string;
  postalCode?: string;
  city?: string;
  state?: string;
  country?: string;
  designPrimaryColor: string;
  designSecondaryColor: string;
  designNameColor: string;
  designTitleColor: string;
  designTextColor: string;
  designIconColor: string;
  designTextHoverColor: string;
  buttonText: string;
  /** @format int32 */
  buttonSize: number;
  buttonBgColor: string;
  buttonTextColor: string;
  buttonHoverColor: string;
  buttonBorderColor: string;
  links?: VCardLinkInDto[];
}

export interface VCardLinkInDto {
  linkType: ELinkType;
  url: string;
}

export interface WebsiteInDto {
  /** @example "https://osdb.io" */
  url: string;
}

export interface WiFiQRCodeInDto {
  /** @format uuid */
  libraryId?: string;
  title: string;
  description?: string;
  /** @example "MyWiFiNetwork" */
  ssid: string;
  /**
   * @minLength 0
   * @maxLength 63
   * @pattern ^(?!\s*$).+
   * @example "mypassword123"
   */
  password?: string;
  /** @example "WPA2" */
  encryption: 'WPA' | 'WPA2' | 'WEP' | 'NONE';
  /** @example false */
  hidden: boolean;
}

export interface LibraryInDto {
  fileIds?: string[];
  libraryType?: ELibraryType;
}

export interface PageResponseLibraryOutDto {
  result: LibraryOutDto[];
  /** @format int64 */
  total: number;
}

/** @example "COOKIE" */
export enum EAuthType {
  COOKIE = 'COOKIE',
  TOKEN = 'TOKEN',
}

export interface SignUpInDto {
  /** @example "ssmith@osdb.io" */
  email: string;
  language: ELanguage;
  autoLinkQRID?: string;
  googleClickId?: string;
  microsoftClickId?: string;
  authType?: EAuthType;
  dev_experimentGroup?: EExperimentGroup;
}

export interface AuthOutDto {
  /** @format uuid */
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  language: ELanguage;
  currency: ECurrency;
  /** @format int64 */
  totalCodes?: number;
  /** @format int64 */
  totalScans?: number;
  /** @format int64 */
  monthlyScans?: number;
  shouldAskForGPSCoordinates?: boolean;
  isFirstScanSeen?: boolean;
  isFirstQrCodeCreated?: boolean;
  /** @format date-time */
  providedReviewForTrialDate?: string | null;
  accountNotification?: boolean;
  qrNotification?: boolean;
  marketingNotification?: boolean;
  phone?: string | null;
  address?: string | null;
  birthDate?: string | null;
  role: ERole;
  /** @format uuid */
  avatarId?: string | null;
  company?: string | null;
  status: EUserStatus;
  /** @format date-time */
  createdDate: string;
  settings: UserSettingOutDto[];
  plan?: PlanUserOutDto;
  currentPlanDetails?: PlanDetailsOutDto;
  /** @format date-time */
  stripeSyncedDate?: string | null;
  hasVerifiedEmail?: boolean | null;
  usageWarning?: EUsageWarning;
  /** @format date-time */
  newUsageResetDate?: string | null;
  customerGen: ECustomerGen;
  customerSegment?: ECustomerSegment;
  /** @format date-time */
  upsellTopBannerHiddenDate?: string | null;
  accessToken?: string | null;
  refreshToken?: string;
  /** Only provided in non-production environments. Indicates if email sending was skipped for test emails */
  dev_EMAIL_SKIP_SEND?: boolean | null;
  /** Only provided in non-production environments. Contains the plain password assigned during sign up */
  dev_PASSWORD_AFTER_SIGNUP?: string | null;
  /** @format uuid */
  teamId?: string | null;
  teamMemberRole: ETeamMemberRole;
  experimentGroup: EExperimentGroup;
  dev_INSECURE_otp_code?: string;
}

export interface SignInStepOneInDto {
  /** @example "okogutenko+client@osdb.io" */
  email: string;
  /** @example "okogutenko+client@osdb.io" */
  password: string;
  authType?: EAuthType;
}

export interface SignInStepTwoInDto {
  /** @example "dberchiyan@osdb.io" */
  email: string;
  confirmCode: string;
  authType?: EAuthType;
}

export interface UpdateTokensInDto {
  refreshToken: string;
}

export interface AuthTokensOutDto {
  accessToken: string;
  refreshToken: string;
}

export interface InvitationSignUpInDto {
  /** @format uuid */
  invitationToken: string;
  password: string;
  firstName?: string | null;
  lastName?: string | null;
  /** @example "12345678912" */
  phone?: string | null;
  /** @example "Kharkiv, Ukraine" */
  address?: string | null;
  /** @example "1991-10-17" */
  birthDate?: string | null;
  /** @example "OSDB" */
  company?: string | null;
  language: ELanguage;
  authType?: EAuthType;
}

export interface ResetPasswordInDto {
  /** @example "dberchiyan@osdb.io" */
  email: string;
  confirmCode: string;
  /** @example "dberchiyan@osdb.io" */
  newPassword: string;
}

export interface ForgotPasswordInDto {
  /** @example "dberchiyan@osdb.io" */
  email: string;
}

export interface InviteInDto {
  email: string;
  role?: ETeamMemberRole;
}

/** Team member invitation request */
export interface TeamMemberInDto {
  /**
   * User email
   * @example "user@example.com"
   */
  email: string;
  role: ETeamMemberRole;
}

/** Team member status */
export enum ETeamMemberStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

/** Team member response */
export interface TeamMemberOutDto {
  /**
   * Team member ID
   * @format uuid
   */
  id: string;
  /** User */
  user: UserLiteOutDto;
  role: ETeamMemberRole;
  /** Team member status */
  status: ETeamMemberStatus;
  /** @format date-time */
  deletedDate?: string | null;
  /**
   * Creation date
   * @format date-time
   */
  createdDate: string;
}

/** User */
export interface UserLiteOutDto {
  /** @format uuid */
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  role: ERole;
  /** @format uuid */
  avatarId?: string | null;
  status: EUserStatus;
  /** @format date-time */
  createdDate: string;
  experimentGroup: EExperimentGroup;
}

export interface QrCodeBulkCreationOutDto {
  createdCodes?: QRCodeOutDto[];
}

export interface QRCodeBulkCreationInDto {
  qrCodes: QRCodeInDto[];
}

export interface CardMethodOutDto {
  last4: string;
  /** @format int64 */
  expMonth: number;
  /** @format int64 */
  expYear: number;
  brand: string;
}

export interface CustomerAdminOutDto {
  /** @format uuid */
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  deletedEmail?: string | null;
  language: ELanguage;
  currency: ECurrency;
  /** @format int64 */
  totalCodes?: number;
  /** @format int64 */
  totalScans?: number;
  /** @format int64 */
  monthlyScans?: number;
  shouldAskForGPSCoordinates?: boolean;
  accountNotification?: boolean;
  qrNotification?: boolean;
  marketingNotification?: boolean;
  phone?: string | null;
  address?: string | null;
  birthDate?: string | null;
  role: ERole;
  /** @format uuid */
  avatarId?: string | null;
  company?: string | null;
  subscription: CustomerSubscriptionOutDto;
  status: EUserStatus;
  customerId?: string | null;
  chargebeeId?: string | null;
  /** @format date-time */
  stripeSyncedDate?: string | null;
  /** @format date-time */
  deletedDate?: string | null;
  /** @format date-time */
  createdDate: string;
  activeCampaignId?: string | null;
  /** @format date-time */
  lastActiveCampaignSyncedDate?: string | null;
  activeSessions?: UserAdminSessionOutDto[];
  googleClickId?: string | null;
  /** @format date-time */
  trialUsageDate?: string | null;
  hasVerifiedEmail?: boolean | null;
  hasDisputedPayment: boolean;
  customerGen: ECustomerGen;
  customerSegment?: ECustomerSegment;
  /** @format date-time */
  upsellTopBannerHiddenDate?: string | null;
  usedCoupon?: string | null;
  subdomain?: string | null;
  isSubdomainEnabled: boolean;
  teamRole?: ETeamMemberRole;
  experimentGroup: EExperimentGroup;
}

export interface CustomerAdminSyncStripeOutDto {
  beforeSync?: CustomerAdminOutDto;
  afterSync?: CustomerAdminOutDto;
  stripeCustomerInfo?: StripeCustomerInfoOutDto;
  stripeSubscriptionInfo?: StripeSubscriptionInfoOutDto;
  systemSubscriptionInfo?: SystemSubscriptionInfoOutDto;
  reasonFailed?: string;
  outAfter?: string;
  isSuccess?: boolean;
  stripeInformation?: StripeSubscriptionInfoOutDto;
  systemInformation?: SystemSubscriptionInfoOutDto;
}

export interface CustomerSubscriptionOutDto {
  planType: EPlanType;
  planStatus: EPlanStatus;
  currency?: ECurrency;
  planCycle?: EPlanCycle;
  /** @format date-time */
  startOfSubscriptionDate?: string | null;
  /** @format date-time */
  endOfSubscriptionDate?: string | null;
  /** @format date-time */
  endOfTrialSubscriptionDate?: string | null;
  scheduledUpdate?: ScheduleUpdateOutDto;
}

export enum ESubscriptionStatus {
  ACTIVE = 'ACTIVE',
  PAST_DUE = 'PAST_DUE',
  UNPAID = 'UNPAID',
  CANCELED = 'CANCELED',
  INCOMPLETE = 'INCOMPLETE',
  INCOMPLETE_EXPIRED = 'INCOMPLETE_EXPIRED',
  TRIALING = 'TRIALING',
  PAUSED = 'PAUSED',
}

export interface InvoiceOutDto {
  name: string;
  /** @format date-time */
  date: string;
  planType?: EPlanType;
  status: EInvoiceStatus;
  /** @format int64 */
  amount: number;
  currency?: ECurrency;
  urlInvoice?: string | null;
  invoiceId: string;
  failedReason?: string | null;
  openReason?: string | null;
  hasDisputed: boolean;
}

export interface PaymentMethodInfoOutDto {
  cardMethod?: CardMethodOutDto;
  sepaMethod?: SepaMethodOutDto;
}

export interface SepaMethodOutDto {
  last4: string;
  bankCode: string;
  branchCode: string;
  country: string;
}

export interface StripeCustomerInfoOutDto {
  stripeCustomerId?: string;
  email?: string;
  duplicateCustomerIds?: string[];
  duplicateEmails?: string[];
  lastInvoice?: InvoiceOutDto;
  lastInvoiceStatus?: string;
  paymentMethod?: PaymentMethodInfoOutDto;
  hasPaymentMethod?: boolean;
  subscriptionIds?: string[];
  duplicateDbUserIds?: string[];
  duplicateDbEmails?: string[];
}

export interface StripeSubscriptionInfoOutDto {
  stripeCustomerId?: string;
  stripeSubscriptionId?: string;
  subscriptionStatus?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  cancelAt?: string;
  /** @format date-time */
  canceledAt?: string;
  /** @format date-time */
  endedAt?: string;
  /** @format date-time */
  currentPeriodEnd?: string;
  /** @format date-time */
  currentPeriodStart?: string;
}

export interface SystemSubscriptionInfoOutDto {
  resultCustomer?: CustomerAdminOutDto;
  planType?: EPlanType;
  subscriptionStatus?: ESubscriptionStatus;
  /** @format date-time */
  expirationDate?: string;
  /** @format date-time */
  stripeSyncedDate?: string;
}

export interface UserAdminSessionOutDto {
  /** @format uuid */
  id: string;
  ipAddress: string;
  platform: string;
  /** @format date-time */
  lastUsed: string;
  /** @format date-time */
  createdDate: string;
}

export interface SubdomainRegistrationInDto {
  /** @pattern ^[a-z0-9-]{0,20}$ */
  subdomain?: string;
}

export interface CustomerPortalInDto {
  /** @default "https://osdb.io" */
  returnURL: string;
}

export interface CustomerPortalOutDto {
  url: string;
}

export interface ApiKeyOutDto {
  /** @format uuid */
  id: string;
  keyValue: string;
  /** @format int64 */
  totalRequests: number;
  /** @format date-time */
  lastUsed: string;
  /** @format date-time */
  createdDate: string;
}

export interface EmailTestSendInDto {
  /** @example "welcome" */
  mailKey: 'welcome' | 'dynamic_explained';
  /**
   * Required and only meaningful when mailKey=dynamic_explained
   * @pattern a|b
   * @example "a"
   */
  variant?: 'a' | 'b' | null;
  language: ELanguage;
  /** @example "info+test@trueqrcode.com" */
  recipientEmail: string;
  /**
   * Prepended to the real subject line for this send only - lets a human tell several test sends apart in one inbox without touching any real mail's subject.
   * @example "[NL] "
   */
  subjectPrefix?: string | null;
}

export interface EmailSuppressionInDto {
  /** @example "user@example.com" */
  email: string;
  reason: 'HARD_BOUNCE' | 'COMPLAINT' | 'MANUAL' | 'INVALID_ADDRESS' | 'UNSUBSCRIBED';
  providerDetail?: string;
}

export interface EmailSuppressionOutDto {
  /** @format uuid */
  id: string;
  email: string;
  reason: 'HARD_BOUNCE' | 'COMPLAINT' | 'MANUAL' | 'INVALID_ADDRESS' | 'UNSUBSCRIBED';
  providerDetail?: string;
  /** @format date-time */
  createdDate: string;
}

export interface EmailSuppressionImportResultOutDto {
  list?: string;
  /** @format int32 */
  fetched?: number;
  /** @format int32 */
  created?: number;
  /** @format int32 */
  alreadyKnown?: number;
}

export interface AdminActionInDto {
  reason: string;
}

export enum ETimelineRecordType {
  EMAIL_SEND_LOG = 'EMAIL_SEND_LOG',
  EMAIL_REPORT = 'EMAIL_REPORT',
  EMAIL_SCHEDULE = 'EMAIL_SCHEDULE',
}

export interface UserStatusInDto {
  /**
   * @pattern ACTIVE|BANNED|DELETED
   * @example "ACTIVE"
   */
  status: string;
}

export interface InvitationStatusInDto {
  /**
   * @pattern PENDING|CANCELED
   * @example "PENDING"
   */
  status: string;
}

export interface QRCodeChangeOwnerStepTwoInDto {
  newOwnerEmail: string;
  verificationCode: string;
}

export interface QRCodeChangeOwnerStepOneInDto {
  recipientEmail: string;
}

export interface BillingInDto {
  firstName?: string;
  lastName?: string;
  billingEmail?: string;
  companyName?: string;
  country?: string;
  state?: string;
  city?: string;
  zipCode?: string;
  streetAddress?: string;
}

export interface BillingInfoOutDto {
  billing?: BillingOutDto;
}

export interface BillingOutDto {
  firstName?: string | null;
  lastName?: string | null;
  billingEmail: string;
  companyName?: string | null;
  country?: string | null;
  state?: string | null;
  city?: string | null;
  zipCode?: string | null;
  streetAddress?: string | null;
}

export interface ChangePasswordInDto {
  /** @example "dberchiyan@osdb.io" */
  newPassword: string;
  /** @example "dberchiyan@osdb.io" */
  confirmNewPassword: string;
}

export interface UserChangeEmailStepTwoInDto {
  newEmailConfirmCode: string;
}

export interface UserChangeEmailStepOneInDto {
  newEmail: string;
}

export interface TwoFAStepTwoInDto {
  confirmCode: string;
  isEnabled: boolean;
}

export interface QrCodeAdminInDto {
  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface QRCodeAdminOutDto {
  id: string;
  name: string;
  isDeleted: boolean;
  design?: DesignOutDto;
  createdBy?: UserBaseOutDto;
  shouldAskForGPSCoordinates: boolean;
  codeType: ECodeType;
  /** @format int64 */
  amountOfScans?: number | null;
  /** @format int64 */
  monthlyScans?: number | null;
  publicLogoType?: string | null;
  /** @format date-time */
  expireDate?: string | null;
  /** @format date-time */
  createdDate: string;
  website?: WebsiteOutDto;
  pdf?: PDFOutDto;
  multilink?: MultilinkOutDto;
  vcard?: VCardOutDto;
  gs1?: GS1OutDto;
  wifi?: WiFiQRCodeOutDto;
  /** @format date-time */
  deletedDate?: string | null;
  createdWithFlow: ECreatedWithFlow;
  subdomain?: string | null;
  isPasswordProtected?: boolean | null;
}

export interface EmailLifecycleSwitchPatchInDto {
  /** Turn this scope on or off */
  enabled: boolean;
}

export interface EmailLifecycleSwitchOutDto {
  scope: string;
  enabled: boolean;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: string;
}

export interface ResponceBuildVersion {
  version?: string;
  /** @format date-time */
  buildTime?: string;
}

export enum EInvitationStatus {
  PENDING = 'PENDING',
  CANCELED = 'CANCELED',
  REGISTERED = 'REGISTERED',
}

export interface PageResponseUserInvitationOutDto {
  result: UserInvitationOutDto[];
  /** @format int64 */
  total: number;
}

export interface UserInvitationOutDto {
  /** @format uuid */
  id: string;
  email: string;
  /** @format uuid */
  token: string;
  role: ETeamMemberRole;
  status: EInvitationStatus;
  /** @format date-time */
  createdDate: string;
  /** @format uuid */
  invitedBy: string;
}

export interface PageResponseTeamMemberOutDto {
  result: TeamMemberOutDto[];
  /** @format int64 */
  total: number;
}

export enum ETeamStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export interface TeamOutDto {
  /** @format uuid */
  id: string;
  /** User */
  owner: UserLiteOutDto;
  status: ETeamStatus;
  /** @format date-time */
  createdDate: string;
}

export interface PlanSubscriptionOutDto {
  /** @format uuid */
  id: string;
  name: string;
  price: PriceOutDto;
  /** @format date-time */
  createdDate: string;
}

export interface SubscriptionOutDto {
  /** @format uuid */
  id?: string | null;
  subscription: PlanSubscriptionOutDto;
  status: ESubscriptionStatus;
  /** @format date-time */
  createdDate?: string | null;
}

export interface PageResponseSubscriptionCancelFeedbackOutDto {
  result: SubscriptionCancelFeedbackOutDto[];
  /** @format int64 */
  total: number;
}

export interface SubscriptionCancelFeedbackOutDto {
  /** @format uuid */
  id: string;
  /** @format date-time */
  createdDate: string;
  email: string;
  planType: EPlanType;
  planCurrency: ECurrency;
  stripeCustomerId: string;
  stripeSubscriptionId: string;
  primaryReason?: string | null;
  featuresMissingOrImprove?: string | null;
  howToKeepYouAsCustomer?: string | null;
  commentsOrSuggestions?: string | null;
}

export interface PageResponseScanOutDto {
  result: ScanOutDto[];
  /** @format int64 */
  total: number;
}

export interface ScanOutDto {
  /** @format uuid */
  id: string;
  /** @format uuid */
  deviceId: string;
  qrCodeId: string;
  ip: string;
  country?: string | null;
  region?: string | null;
  city?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  providerOrg?: string | null;
  timeZone?: string | null;
  operationSystem?: string | null;
  deviceType?: string | null;
  browserName?: string | null;
  browserType?: string | null;
  browserVersion?: string | null;
  basedOn?: 'IP' | 'GPS' | null;
  serviceError?: string | null;
  /** @format date-time */
  createdDate: string;
}

export interface PageResponseDesignOutDto {
  result: DesignOutDto[];
  /** @format int64 */
  total: number;
}

export interface DisabledReasonsOutDto {
  reasonCode?: ERestrictionError;
}

export interface PageResponsePlanOutDto {
  result: PlanOutDto[];
  /** @format int64 */
  total: number;
}

export interface PlanLimitOutDto {
  planType: EPlanType;
  /** @format int32 */
  amountMaxQrCodes?: number | null;
  /** @format int32 */
  amountMaxScans?: number | null;
  hasTemplates: boolean;
  hasLabels: boolean;
  hasRealTimeDataDashboard: boolean;
  hasTrackScanTimeOfDay: boolean;
  hasTrackScanLocation: boolean;
  hasTrackScanDevice: boolean;
  hasTrackScanGPS: boolean;
  hasQrDesignCustomisations: boolean;
  hasBulkQrCodeGeneration: boolean;
  /** @format int32 */
  amountOfMaxBulkQrCode?: number | null;
  gdprCompliant: boolean;
  ccpaCompliant: boolean;
  knowledgeBase: boolean;
  emailSupport: boolean;
  dedicatedCustomerSuccessManager: boolean;
  hasTeamAccess: boolean;
  hasWhiteLabel: boolean;
  hasApiKey: boolean;
  /** @format int32 */
  scanAnalyticsQuantity?: number | null;
  scanAnalyticsUnit?: EScanAnalyticUnit | null;
  hasFileExtensions: boolean;
  fileExtensions: string[];
  qrAdjustable?: boolean | null;
}

export interface PlanOutDto {
  /** @format uuid */
  id: string;
  name: string;
  type: EPlanType;
  prices: PriceOutDto[];
  planLimit: PlanLimitOutDto;
  disabledReasons?: DisabledReasonsOutDto[];
  isTrial?: boolean;
  /** @format date-time */
  createdDate: string;
}

export enum EEmailTopic {
  WARNING80PERCENTSCANLIMIT = 'WARNING_80_PERCENT_SCAN_LIMIT',
  EXPIRED_QR_SCANNED = 'EXPIRED_QR_SCANNED',
  SIGN_UP = 'SIGN_UP',
  PLAN_UPGRADE = 'PLAN_UPGRADE',
  PLAN_DOWNGRADE = 'PLAN_DOWNGRADE',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  QR_CODE_CHANGE_OWNER = 'QR_CODE_CHANGE_OWNER',
  ACCOUNT_OVER_SCAN_LIMIT = 'ACCOUNT_OVER_SCAN_LIMIT',
  EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
  TEAM_INVITATION = 'TEAM_INVITATION',
  TWO_FA_CONFIRM = 'TWO_FA_CONFIRM',
  EMAIL_CHANGE = 'EMAIL_CHANGE',
}

export interface EmailReportOutDto {
  /** @format uuid */
  id: string;
  subject: string;
  topic: EEmailTopic;
  /** @format uuid */
  userId: string;
  recipientEmail: string;
  context: string;
  language: ELanguage;
  /** @format date-time */
  createdDate: string;
}

export interface PageResponseEmailReportOutDto {
  result: EmailReportOutDto[];
  /** @format int64 */
  total: number;
}

export interface DashboardOutDto {
  /** @format int64 */
  totalQRCodes: number;
  /** @format int64 */
  totalScans: number;
  /** @format int64 */
  monthlyScans: number;
  /** @format int64 */
  totalUsers: number;
  /** @format int64 */
  monthlyUsers: number;
}

export enum ESubscriptionAdminStatus {
  ACTIVE = 'ACTIVE',
  CANCELED_NOT_EXPIRED = 'CANCELED_NOT_EXPIRED',
  EXPIRED = 'EXPIRED',
}

export interface PageResponseCustomerAdminOutDto {
  result: CustomerAdminOutDto[];
  /** @format int64 */
  total: number;
}

export interface PageResponseInvoiceOutDto {
  result: InvoiceOutDto[];
  /** @format int64 */
  total: number;
}

export interface UserSettingListOutDto {
  settings: UserSettingOutDto[];
}

export interface UserSessionListOutDto {
  sessions: UserSessionOutDto[];
}

export interface UserSessionOutDto {
  /** @format uuid */
  id: string;
  ipAddress: string;
  platform: string;
  isCurrent: boolean;
  /** @format int64 */
  totalRequests: number;
  /** @format date-time */
  createdDate: string;
}

export interface PageResponseApiKeyOutDto {
  result: ApiKeyOutDto[];
  /** @format int64 */
  total: number;
}

export interface ScansByLocationOutDto {
  /** @format int64 */
  totalCountries: number;
  /** @format int64 */
  totalCities: number;
  withLocation: WithLocationOutDto[];
  unknownLocation: UnknownLocationOutDto[];
}

export interface UnknownLocationOutDto {
  /** @format int64 */
  totalScans: number;
  /** @format int64 */
  totalUsers: number;
}

export interface WithLocationOutDto {
  country: string;
  city: string;
  /** @format int64 */
  totalScans: number;
  /** @format int64 */
  totalUsers: number;
  /** @format double */
  cityLatitude: number;
  /** @format double */
  cityLongitude: number;
}

export interface OverallAnalyticOutDto {
  /** @format int64 */
  totalQRCodes: number;
  /** @format int64 */
  totalScans: number;
  /** @format int64 */
  totalUsers: number;
}

export interface ChartAnalyticOutDto {
  results: ChartResultsOutDto[];
  /** @format int64 */
  total: number;
}

export interface ChartResultsOutDto {
  /** @format int64 */
  total: number;
  /** @format date-time */
  date: string;
}

export interface PageResponseAdminOutDto {
  result: AdminOutDto[];
  /** @format int64 */
  total: number;
}

export interface PageResponseTeamAdminOutDto {
  result: TeamAdminOutDto[];
  /** @format int64 */
  total: number;
}

export interface TeamAdminOutDto {
  /** @format uuid */
  id: string;
  /** User */
  owner: UserLiteOutDto;
  status: ETeamStatus;
  /** @format int64 */
  amountOfActiveMembers: number;
  /** @format int64 */
  amountOfDeletedMembers: number;
  /** @format int64 */
  amountOfPendingMembers: number;
  /** @format date-time */
  createdDate: string;
}

export interface PageResponseTeamAdminMemberOutDto {
  result: TeamAdminMemberOutDto[];
  /** @format int64 */
  total: number;
}

/** Team member response */
export interface TeamAdminMemberOutDto {
  /**
   * Team member ID
   * @format uuid
   */
  id: string;
  /** User */
  user: UserLiteOutDto;
  role: ETeamMemberRole;
  /** Team member status */
  status: ETeamMemberStatus;
  /** @format date-time */
  deletedDate?: string | null;
  /**
   * Creation date
   * @format date-time
   */
  createdDate: string;
}

export interface PageResponseQRCodeAdminOutDto {
  result: QRCodeAdminOutDto[];
  /** @format int64 */
  total: number;
}

export interface PageResponseQrCodeRiskLogOutDto {
  result: QrCodeRiskLogOutDto[];
  /** @format int64 */
  total: number;
}

export interface QrCodeRiskLogOutDto {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdDate?: string;
  qrCodeId?: string;
  /** @format uuid */
  userId?: string;
  clientIp?: string;
  accountCategory?: 'ANONYMOUS' | 'FREE_OR_TRIAL' | 'PAID';
  sourceAction?: 'CREATE' | 'PATCH' | 'BULK_JSON' | 'BULK_CSV' | 'SCAN_VELOCITY';
  inputUrl?: string;
  finalUrl?: string;
  localCheckVerdict?:
    | 'OK'
    | 'MALFORMED_URL'
    | 'INVALID_SCHEME'
    | 'CLOUD_METADATA_ADDRESS'
    | 'PRIVATE_ADDRESS_NOT_VERIFIABLE'
    | 'IP_LITERAL_HOST'
    | 'SELF_REFERENTIAL_CHAIN';
  resolutionVerdict?:
    | 'OK'
    | 'BLOCKED_CLOUD_METADATA'
    | 'BLOCKED_PRIVATE_ADDRESS'
    | 'SELF_REFERENTIAL_CHAIN'
    | 'TOO_MANY_REDIRECTS'
    | 'UNREACHABLE_OR_TIMEOUT';
  webRiskVerdict?: 'CLEAN' | 'MALWARE' | 'SOCIAL_ENGINEERING' | 'UNWANTED_SOFTWARE' | 'UNKNOWN_OUTAGE';
  rateLimitExceeded?: boolean;
  wouldBlock?: boolean;
  reviewed?: boolean;
}

export interface RiskWhitelistDomainOutDto {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdDate?: string;
  domain?: string;
}

export interface PageResponseQrCodeRiskLogGroupedOutDto {
  result: QrCodeRiskLogGroupedOutDto[];
  /** @format int64 */
  total: number;
}

export interface QrCodeRiskLogGroupedOutDto {
  qrCodeId?: string;
  /** @format uuid */
  userId?: string;
  accountCategory?: 'ANONYMOUS' | 'FREE_OR_TRIAL' | 'PAID';
  lastSourceAction?: 'CREATE' | 'PATCH' | 'BULK_JSON' | 'BULK_CSV' | 'SCAN_VELOCITY';
  lastFinalUrl?: string;
  lastWebRiskVerdict?: 'CLEAN' | 'MALWARE' | 'SOCIAL_ENGINEERING' | 'UNWANTED_SOFTWARE' | 'UNKNOWN_OUTAGE';
  wouldBlock?: boolean;
  reviewed?: boolean;
  /** @format int32 */
  flagCount?: number;
  riskBlocked?: boolean;
  /** @format date-time */
  firstFlaggedDate?: string;
  /** @format date-time */
  lastFlaggedDate?: string;
}

export interface PageResponseEmailSuppressionOutDto {
  result: EmailSuppressionOutDto[];
  /** @format int64 */
  total: number;
}

export enum EEmailHealthStatus {
  OK = 'OK',
  WARNING = 'WARNING',
  CRITICAL = 'CRITICAL',
}

export enum ENotSentAssessment {
  NORMAL = 'NORMAL',
  INVESTIGATE = 'INVESTIGATE',
  UNKNOWN = 'UNKNOWN',
}

export interface EmailNotSentRowOutDto {
  mailKey: string;
  reason: string;
  /** @format int64 */
  count: number;
  assessment: ENotSentAssessment;
  fromSendGrid: boolean;
}

export interface EmailReportKpisOutDto {
  /** @format int64 */
  sent: number;
  /** @format double */
  deliveredPercent: number;
  /** @format double */
  bouncePercent: number;
  /** @format double */
  complaintPercent: number;
  /** @format double */
  unsubscribedPercent: number;
  /** @format int64 */
  upgradesWithin72h: number;
  bounceStatus: EEmailHealthStatus;
  complaintStatus: EEmailHealthStatus;
}

export interface EmailReportMailTypeRowOutDto {
  mailKey: string;
  /** @format int64 */
  sent: number;
  /** @format double */
  deliveredPercent: number;
  /** @format double */
  openedPercent: number;
  /** @format double */
  clickedPercent: number;
  /** @format double */
  unsubscribedPercent: number;
  /** @format double */
  complaintPercent: number;
  complaintAboveThreshold: boolean;
  unsubscribedAboveThreshold: boolean;
  /** @format int64 */
  upgradesWithin72h: number;
}

export interface EmailReportSummaryOutDto {
  kpis: EmailReportKpisOutDto;
  perMailType: EmailReportMailTypeRowOutDto[];
  notSent: EmailNotSentRowOutDto[];
  /** @format date */
  percentagesMeasuredSince: string;
}

export enum EEmailReportGranularity {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export interface EmailReportSeriesBucketOutDto {
  /** @format date */
  bucketStart: string;
  label: string;
  partial: boolean;
  sentByCategory: Record<string, number>;
  /** @format double */
  bouncePercent: number;
  /** @format double */
  complaintPercent: number;
}

export interface EmailReportSeriesOutDto {
  granularity: EEmailReportGranularity;
  buckets: EmailReportSeriesBucketOutDto[];
}

export interface EmailLogEntryOutDto {
  /** @format uuid */
  recordId: string;
  recordType: ETimelineRecordType;
  /** @format date-time */
  at: string;
  recipientEmail?: string;
  mailKey: string;
  category?: string;
  locale?: string;
  status: string;
  details?: string;
  hasContext: boolean;
}

export interface PageResponseEmailLogEntryOutDto {
  result: EmailLogEntryOutDto[];
  /** @format int64 */
  total: number;
}

export interface EmailDeliverabilityKpisOutDto {
  /** @format int64 */
  bouncedHard: number;
  /** @format int64 */
  blocked: number;
  /** @format int64 */
  deferred: number;
  /** @format int64 */
  complained: number;
  /** @format int64 */
  dropped: number;
  /** @format int64 */
  suppressionListSize: number;
}

export interface EmailDeliverabilityOutDto {
  kpis: EmailDeliverabilityKpisOutDto;
  recentProblems: EmailRecentProblemOutDto[];
  domains: EmailDomainDeliverabilityRowOutDto[];
}

export interface EmailDomainDeliverabilityRowOutDto {
  domainGroup: string;
  /** @format int64 */
  sent: number;
  /** @format double */
  deliveredPercent: number;
  /** @format double */
  bouncePercent: number;
  /** @format double */
  complaintPercent: number;
  /** @format double */
  openedPercent: number;
  /** @format double */
  clickedPercent: number;
  /** @format double */
  baselineDeliveredPercent?: number;
  /** @format double */
  baselineBouncePercent?: number;
  /** @format double */
  baselineComplaintPercent?: number;
  /** @format double */
  baselineOpenedPercent?: number;
  /** @format double */
  baselineClickedPercent?: number;
  belowVolumeFloor: boolean;
  clickDropFlag: boolean;
}

export interface EmailRecentProblemOutDto {
  /** @format date-time */
  occurredAt: string;
  recipientEmail?: string;
  eventType: string;
  reason?: string;
  bounceClassification?: string;
}

export interface CustomerEmailHeaderOutDto {
  /** @format uuid */
  userId?: string;
  email?: string;
  fullName?: string;
  planType?: EPlanType;
  customerGen?: ECustomerGen;
  /** @format int32 */
  trialDay?: number;
  track?: 'A' | 'B' | 'C';
  /** @format int64 */
  trackCodeCount?: number;
  /** @format int64 */
  trackScanCount?: number;
  businessDomain?: boolean;
  language?: ELanguage;
  timeZone?: string;
  journeys?: CustomerJourneyStatusOutDto[];
  suppression?: CustomerSuppressionStatusOutDto;
}

export interface CustomerEmailOverviewOutDto {
  header?: CustomerEmailHeaderOutDto;
  preferences?: CustomerPreferenceOutDto[];
  timeline?: CustomerTimelineEntryOutDto[];
}

export interface CustomerJourneyStatusOutDto {
  journeyKey?: string;
  state?: 'ACTIVE' | 'COMPLETED' | 'STOPPED';
  /** @format date-time */
  enrolledAt?: string;
  stopReason?: string;
  /** @format date-time */
  stoppedAt?: string;
}

export interface CustomerPreferenceOutDto {
  category?: EEmailCategory;
  optedIn?: boolean;
  /** @format date-time */
  optedOutAt?: string;
  source?: EPreferenceSource;
}

export interface CustomerSuppressionStatusOutDto {
  suppressed?: boolean;
  /** @format uuid */
  suppressionId?: string;
  reason?: 'HARD_BOUNCE' | 'COMPLAINT' | 'MANUAL' | 'INVALID_ADDRESS' | 'UNSUBSCRIBED';
  /** @format date-time */
  providerConfirmedAt?: string;
  confirmedAtSendGrid?: boolean;
}

export interface CustomerTimelineEntryOutDto {
  kind?: ETimelineEntryKind;
  /** @format uuid */
  recordId?: string;
  recordType?: ETimelineRecordType;
  mailKey?: string;
  category?: string;
  locale?: string;
  /** @format date-time */
  at?: string;
  skipReason?: string;
  conditionsNotYetChecked?: boolean;
  events?: CustomerTimelineEventOutDto[];
  droppedReason?: string;
  contentAvailable?: boolean;
  /** @format int32 */
  seriesNo?: number;
  /** @format int32 */
  sequenceNo?: number;
  /** @format int32 */
  sequenceMax?: number;
}

export interface CustomerTimelineEventOutDto {
  eventType?: string;
  /** @format date-time */
  occurredAt?: string;
  reason?: string;
  bounceClassification?: string;
  linkUrl?: string;
}

export enum EEmailCategory {
  ACCOUNT = 'ACCOUNT',
  QR_NOTIFICATION = 'QR_NOTIFICATION',
  TRIAL_LIFECYCLE = 'TRIAL_LIFECYCLE',
  TIPS = 'TIPS',
}

export enum EPreferenceSource {
  PREFERENCE_PAGE = 'PREFERENCE_PAGE',
  LIST_UNSUBSCRIBE = 'LIST_UNSUBSCRIBE',
  MANUAL = 'MANUAL',
  IMPORT = 'IMPORT',
  MIGRATION = 'MIGRATION',
}

export enum ETimelineEntryKind {
  SENT = 'SENT',
  SCHEDULED = 'SCHEDULED',
  SKIPPED = 'SKIPPED',
  DROPPED = 'DROPPED',
}

export interface CustomerRenderedMailOutDto {
  subject?: string;
  template?: string;
  html?: string;
}

export interface CustomerSearchResultOutDto {
  /** @format uuid */
  userId?: string;
  fullName?: string;
  email?: string;
}

export interface AdminDashboardExpiringTrialsRowOutDto {
  /** @format date */
  day: string;
  /** @format int64 */
  trackC: number;
  /** @format int64 */
  trackB: number;
  /** @format int64 */
  trackA: number;
}

export interface AdminDashboardScanLimitRowOutDto {
  maskedEmail: string;
  plan: string;
  /** @format int64 */
  monthlyScans: number;
  /** @format int64 */
  scanLimit: number;
  /** @format double */
  percentUsed: number;
  overLimit: boolean;
}

export interface AdminDashboardScheduledCancellationRowOutDto {
  maskedEmail: string;
  plan: string;
  /** @format date */
  expiresOn: string;
  /** @format int64 */
  monthlyScans: number;
}

export interface AdminDashboardUpcomingOutDto {
  expiringTrials: AdminDashboardExpiringTrialsRowOutDto[];
  renewals: AdminDashboardWeeklyCountOutDto[];
  scheduledCancellations: AdminDashboardScheduledCancellationRowOutDto[];
  nearScanLimit: AdminDashboardScanLimitRowOutDto[];
}

export interface AdminDashboardWeeklyCountOutDto {
  /** @format date */
  weekStart: string;
  /** @format int64 */
  value: number;
  running: boolean;
}

export interface AdminDashboardHourlyRowOutDto {
  /** @format int32 */
  hour: number;
  /** @format int64 */
  today: number;
  /** @format double */
  averageSameWeekday: number;
  running: boolean;
}

export interface AdminDashboardTodayFigureOutDto {
  label: string;
  /** @format int64 */
  value: number;
  comparisonLabel: string;
}

export interface AdminDashboardTodayOutDto {
  hourly: AdminDashboardHourlyRowOutDto[];
  figures: AdminDashboardTodayFigureOutDto[];
}

export interface AdminDashboardTileOutDto {
  label: string;
  /** @format int64 */
  value: number;
  /** @format double */
  deltaPercent?: number;
  /** @format int64 */
  comparisonValue: number;
  comparisonLabel: string;
  running: boolean;
  sparkline: number[];
}

export interface AdminDashboardTilesOutDto {
  signupsToday: AdminDashboardTileOutDto;
  scansToday: AdminDashboardTileOutDto;
  activeTrials: AdminDashboardTileOutDto;
  payingCustomers: AdminDashboardTileOutDto;
}

export interface AdminDashboardCodeTypeRowOutDto {
  label: string;
  /** @format int64 */
  count: number;
  /** @format double */
  percent: number;
}

export interface AdminDashboardQrCodesOutDto {
  perWeek: AdminDashboardWeeklyCountOutDto[];
  perType: AdminDashboardCodeTypeRowOutDto[];
}

export interface AdminDashboardMoneyBandOutDto {
  conversionPerWeek: AdminDashboardWeeklyPercentOutDto[];
  churnPerMonth: AdminDashboardMonthlyCountOutDto[];
  payingBaseOverTime: AdminDashboardWeeklyCountOutDto[];
}

export interface AdminDashboardMonthlyCountOutDto {
  /** @format date */
  monthStart: string;
  /** @format int64 */
  value: number;
  running: boolean;
}

export interface AdminDashboardWeeklyPercentOutDto {
  /** @format date */
  weekStart: string;
  /** @format double */
  percent: number;
}

export interface AdminDashboardCohortRowOutDto {
  /** @format date */
  cohortWeekStart: string;
  /** @format int64 */
  cohortSize: number;
  /** @format int64 */
  firstCodeCount: number;
  /** @format double */
  firstCodePercent: number;
  /** @format int64 */
  firstScanCount: number;
  /** @format double */
  firstScanPercent: number;
  /** @format int64 */
  paidCount: number;
  /** @format double */
  paidPercent: number;
  mature: boolean;
}

export interface AdminDashboardFunnelBandOutDto {
  cohortTrend: AdminDashboardCohortRowOutDto[];
  /** @format date */
  lastFullCohortWeekStart: string;
  lastFullCohortFunnel: AdminDashboardFunnelStepOutDto[];
  sourcesPerWeek: AdminDashboardSourceWeekOutDto[];
  sourceConversion90d: AdminDashboardSourceConversionRowOutDto[];
}

export interface AdminDashboardFunnelStepOutDto {
  label: string;
  /** @format int64 */
  count: number;
  /** @format double */
  percentOfPrevious?: number;
}

export interface AdminDashboardSourceConversionRowOutDto {
  source: string;
  /** @format int64 */
  signups: number;
  /** @format int64 */
  paid: number;
  /** @format double */
  conversionPercent: number;
}

export interface AdminDashboardSourceWeekOutDto {
  /** @format date */
  weekStart: string;
  /** @format int64 */
  googleAds: number;
  /** @format int64 */
  googleLogin: number;
  /** @format int64 */
  email: number;
}

/** Base error code interface */
type BaseErrorCode = object;

type BaseErrorCodeTypeMapping<Key, Type> = {
  type: Key;
} & Type;

// Manually restored, see gen-swagger-types.sh's own comment above this block.
export enum EAccountRiskCategory {
  ANONYMOUS = 'ANONYMOUS',
  FREE_OR_TRIAL = 'FREE_OR_TRIAL',
  PAID = 'PAID',
}

export enum EQrCodeSourceAction {
  CREATE = 'CREATE',
  PATCH = 'PATCH',
  BULK_JSON = 'BULK_JSON',
  BULK_CSV = 'BULK_CSV',
  SCAN_VELOCITY = 'SCAN_VELOCITY',
}

export enum EWebRiskVerdict {
  CLEAN = 'CLEAN',
  MALWARE = 'MALWARE',
  SOCIAL_ENGINEERING = 'SOCIAL_ENGINEERING',
  UNWANTED_SOFTWARE = 'UNWANTED_SOFTWARE',
  UNKNOWN_OUTAGE = 'UNKNOWN_OUTAGE',
}
